import React from 'react';
import { useParams } from 'react-router-dom';

// import { Card } from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Link } from 'react-router-dom';
// import { faHome } from '@fortawesome/free-solid-svg-icons';

import IntestazioneAmbito from '../components-csvc/IntestazioneAmbito';
import { CompilaQuestionarioRicadute } from './CompilaQuestionarioRicadute.js';
import { useSelector } from 'react-redux';


/**** CompilaQuestionarioAmbito ****/
const CompilaQuestionarioAmbito = () => {
  const myParams = useParams();
   
  // leggo da redux struttura ambiti questionario corrente
  const ambiti = useSelector((state) => state.questCorrente.ambiti);

  // estraggo dall'array ambiti l'oggetto con key = amito da estrarre (myParams)
  const ambitoCsvcCodice = myParams.ambitoCsvcCodice;

  const ambito = ambiti.find(
    (item) => item.key === ambitoCsvcCodice
  );

  if (ambito.enabled) return (
      <>
      <IntestazioneAmbito ambito={ambito} />
      <CompilaQuestionarioRicadute ricadute={ambito.ricadute} />
      </>
    )    
  else return (
    <>
    <IntestazioneAmbito ambito={ambito} />
    <p className="text-danger  fw-medium"><strong>L'ambito {ambito.key} - {ambito.descrizione} è stato disabilitato</strong></p>
    </>
  );
};

export default CompilaQuestionarioAmbito;

/*

/**** CompilaQuestionarioAmbito **** /
const CompilaQuestionarioAmbito = () => {
  // const aziendaCodice = 'alfa';
 
  const ambiti = useSelector((state) => state.questCorrente.ambiti);

  const myParams = useParams();

  const ambitoCsvcCodice = myParams.ambitoCsvcCodice;

  const ambito = csvcQuestionarioV1.ambiti.find(
    (item) => item.key === ambitoCsvcCodice
  );




  return (
    <>
    <IntestazioneAmbito ambito={ambito} />
    <CompilaQuestionarioRicadute ricadute={ambito.ricadute} />
    </>
  );
};

export default CompilaQuestionarioAmbito;


*/